module.exports = __webpack_public_path__ + "img/gf.6f5d111a.svg";